import React from 'react';
import { GridRow as Component } from '@vfuk/core-grid';
const GridRow = props => {
    return React.createElement(Component, Object.assign({}, props));
};
export default GridRow;
